import { Children, CSSProperties, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useGetVCEByOrderId, useMyOrderDetail } from "../../../api/order";
import OrderCard from "../../../components/cards/order-card/OrderCard";
import Map from "../../../components/Map";
import DueDateCard from "../../../components/cards/due-date-card/DueDateCard";
import { FileOutlined, UserOutlined } from "@ant-design/icons";

import { useContractByOrderIdList } from "../../../api/contract";
import WithAuth from "../../../hoc/WithAuth";
import VCETable from "../../../components/tables/order/VCETable";
import ContractTable from "../../../components/tables/order/ContractTable";
import OrderTrackingGraph from "../../../components/OrderTrackingGraph";
import { useGetFarmingStageByOrderId } from "../../../api/farming_stage";
import { Checkbox, Collapse, Space, Spin, Tabs } from "antd";
import { getStatusColor } from "../../../util/statusColor";

const container: CSSProperties = {
  fontFamily: "Poppins",
  borderRadius: 8.5,
  marginTop: 25,
  backgroundColor: "white",
  paddingTop: 28,
  paddingBottom: 28,
  paddingLeft: 75,
  paddingRight: 75,
};

function MyOrderDetailPage() {
  const { id } = useParams();
  const [viewAllContracts, setViewAllContracts] = useState(false);
  const [viewAllVces, setViewAllVces] = useState(false);

  const [tableIndex, setTableIndex] = useState<number>(0);
  const [searchText, setSearchText] = useState<string>("");
  const { data: contractsData } = useContractByOrderIdList(id || "");
  const {
    data: contracts,
    isLoading,
    refetch: refetchContracts,
  } = useContractByOrderIdList(id);
  const {
    data: vces,
    isLoading: vceLoading,
    refetch: refetchVce,
  } = useGetVCEByOrderId(id);

  const { data: order } = useMyOrderDetail(id || "");
  const { data: trackingData, refetch } = useGetFarmingStageByOrderId(id);
  const [graphData, setGraphData] = useState<any>([]);

  const [tags, setTags] = useState<{ [x: string]: any }[]>([]);
  const [activeTab, setActiveTab] = useState("1");
  
  useEffect(() => {
    if (order && order.data && order.data.data && order.data.data.tags) {
      const _tags = JSON.parse(order.data.data.tags);
      setTags([_tags]);
    }
  }, [order]);

  useEffect(() => {
    if (
      trackingData &&
      trackingData.data &&
      trackingData.data.data &&
      trackingData.data.data.data
    ) {
      const val = Object.entries(trackingData.data.data.data).map((v: any) => {
        return { date: v[0], ...v[1] };
      });
      if (val) {
        setGraphData(val);
      }
    }
  }, [trackingData]);

  useEffect(() => {
    if (id) {
      refetch();
    }
  }, [id]);

  const tabItems = [
    {
      key: "1",
      label: "FARMING STATUS",
      children: (
        <div style={container}>
          <div
            style={{
              backgroundColor: "#E9EDF4",
              padding: "15px",
              borderRadius: "8.5px",
              fontWeight: 500,
              fontSize: "24px",
              marginBottom: "30px",
            }}
          >
            Farming Status
          </div>
          <OrderTrackingGraph data={graphData} />
        </div>
      ),
    },
    // {
    //   key: "2",
    //   label: "MAP",
    //   children: (
    //     <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
    //       {id && <Map orderId={id} />}
    //     </div>
    //   ),
    // },
    {
      key: "2",
      label: "CONTRACTS",
      children: (
        <div
          className="hidden md:block"
          style={{
            borderRadius: 8.5,
            marginTop: 25,
            paddingLeft: 50,
            paddingRight: 50,
            paddingTop: 22,
            backgroundColor: "white",
          }}
        >
          {id && <ContractTable orderId={id} />}
        </div>
      ),
    },
    {
      key: "3",
      label: "VALUE CHAIN EXECUTORS",
      children: (
        <div
          className="hidden md:block"
          style={{
            borderRadius: 8.5,
            marginTop: 25,
            paddingLeft: 50,
            paddingRight: 50,
            paddingTop: 22,
            backgroundColor: "white",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: 80,
              backgroundColor: "#EEF3F8",
              borderRadius: 8.4,
              marginBottom: 22,
              fontFamily: "Poppins",
              fontSize: 22,
            }}
          >
            Value chain executors
          </div>
          {id && <VCETable orderId={id} />}
        </div>
      ),
    },
   
  ];

  return (
    <>
      <div className="flex flex-col gap-[12px]">
        <div className="flex flex-col md:flex-row justify-between gap-[20px]">
          {order && order.data && order.data.data && (
            <OrderCard
              off_taker={order.data.data.orgName}
              start_date={order.data.data.startingDate}
              due_date={order.data.data.dueDate}
              product={order.data.data.product}
              quantity={order.data.data.quantity}
              status={order.data.data.status}
            />
          )}
          {(!order || !order.data || !order.data.data) && (
            <div className="w-[80%] bg-white rounded-xl flex flex-col gap-5 justify-center items-center">
              <div className="text-2xl text-[#009602]">
                Order detail loading...
              </div>
              <Spin />
            </div>
          )}
          {order && order.data && (
            <DueDateCard
              dueDate={order.data.data.dueDate}
              product={order.data.data.product}
            />
          )}
          <div className="flex flex-row md:flex-col gap-[20px]">
            <div
              className="flex flex-col w-1/2 md:w-full border-2 rounded-xl bg-white h-[160px]"
              onClick={() => setTableIndex(0)}
            >
              <div className="flex justify-between items-center px-4 md:px-8 pt-4">
                <div className="text-black text-xl md:text-2xl">Farmers</div>
                <UserOutlined
                  style={{ color: "#268D60", fontSize: 40 }}
                  onClick={() => setTableIndex(0)}
                />
              </div>
              <div className="w-full h-full flex justify-center items-center font-semibold text-4xl">
                {contractsData?.data.data.length}
              </div>
            </div>
            <div
              className="flex flex-col w-1/2 md:w-full border-2 rounded-xl bg-white h-[160px]"
              onClick={() => setTableIndex(1)}
            >
              <div className="flex justify-between items-center px-4 md:px-8 pt-4">
                <div className="text-black text-xl md:text-2xl">Contracts</div>
                <FileOutlined
                  style={{ color: "#268D60", fontSize: 40 }}
                  onClick={() => setTableIndex(1)}
                />
              </div>
              <div className="w-full h-full flex justify-center items-center font-semibold text-4xl">
                {contractsData?.data.data.length}
              </div>
            </div>
          </div>
        </div>
      </div>
       <Tabs
          style={{
            background: "gray",
            fontWeight: 700,
          }}
          type="card"
          className="text-black"
          defaultActiveKey="1"
          items={tabItems}
          onChange={(key) => setActiveTab(key)}
        />
    </>
  );
}

export default WithAuth(MyOrderDetailPage);
